import React from 'react'

// Shared bits for the Catalog pages' score/url columns (TDC-1499 phase 3).

// Same thresholds the PDP score chips use (PdpScoreStatus): healthy ≥ 70,
// middling ≥ 40, poor below.
const scoreColors = (score: number): { fg: string; bg: string } => {
  if (score >= 70) return { fg: 'var(--up)', bg: 'var(--up-bg)' }
  if (score >= 40) return { fg: 'var(--accent-text)', bg: 'var(--tint)' }
  return { fg: 'var(--down)', bg: 'var(--down-bg)' }
}

// Average-PDP-score pill. Renders nothing when there is no score yet —
// callers show their own em-dash when they want a placeholder.
export function ScoreChip({
  score,
  title = "Average of the latest PDP scores across this row's scored products",
}: {
  score: number | null | undefined
  title?: string
}) {
  if (typeof score !== 'number') return null
  const { fg, bg } = scoreColors(score)
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-bold shrink-0"
      style={{ color: fg, background: bg }}
      title={title}
    >
      {score}
    </span>
  )
}

// Manual categories carry a manual:// placeholder in their url column (the
// column is NOT NULL) — only real web URLs are worth displaying/linking.
export const isDisplayableUrl = (url: string | null | undefined): url is string =>
  !!url && /^https?:\/\//i.test(url)

// "View products" row action (Catalog > Categories and Brands). A row with
// nothing imported has nothing to show on the Catalog tab, so it points at
// Discovered instead — that's where its crawled rows are waiting. The count
// is optional (an older API omits it); undefined keeps the Catalog tab.
export const viewsDiscoveredProducts = (catalogCount: number | undefined): boolean =>
  catalogCount === 0
